/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */

/**
 * Status of the step:
  * `approved` - 承認済み
  * `in_progress` - 進行中
  * `not_approved` (no label)

 */
export type ApprovingInvoiceReportApprovalRouteResponseStepsItemStatus =
  (typeof ApprovingInvoiceReportApprovalRouteResponseStepsItemStatus)[keyof typeof ApprovingInvoiceReportApprovalRouteResponseStepsItemStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApprovingInvoiceReportApprovalRouteResponseStepsItemStatus = {
  approved: 'approved',
  in_progress: 'in_progress',
  not_approved: 'not_approved',
} as const;
